// Aviso de restrição do número de WhatsApp no cabeçalho (MET-22).
//
// ⚠️ USA `canal/restricao`, NUNCA `canal/saude`. São dois endpoints separados de
// propósito: o permissivo devolve só `{ restricted, since }` e **jamais** contém
// `qualityRating`. Buscar `canal/saude` aqui — ainda que só para "mostrar se for
// GESTOR" — colocaria a nota de qualidade no cache do navegador de todo
// atendente, e a separação do back deixaria de valer.
//
// O operacional precisa saber que HÁ restrição (para não disparar campanha em
// número penalizado); o diagnóstico é do gestor, na aba WhatsApp.
import { Badge } from '@/components/ui/Badge';
import { AlertTriangleIcon } from '@/components/icons';
import { useMetricsNumberRestrictionQuery } from '../api';
import { useMetricsRbac } from '../hooks/useMetricsRbac';

export function NumberRestrictionBadge() {
  const rbac = useMetricsRbac();
  // Sem papel resolvido ainda (sessão carregando) não perguntamos nada.
  const { data } = useMetricsNumberRestrictionQuery(
    { period: '7d' },
    { skip: rbac.role === null },
  );

  if (!data?.restricted) return null;

  const desde = data.since
    ? ` desde ${new Date(data.since).toLocaleDateString('pt-BR')}`
    : '';

  return (
    <Badge variant="warning" leadingIcon={<AlertTriangleIcon size={12} aria-hidden="true" />}>
      {/* Cor + ícone + TEXTO: a restrição não pode existir só como pill amarela. */}
      Envio restrito{desde}
    </Badge>
  );
}
